<template>
  <div v-focus-trap class="overlay-container">
    <div v-show="isUserInactive || isSlotPresent" class="overlayDiv">
      <p class="descriptionText" v-t="overlayDescriptionText"></p>
      <button
        class="resumeButton"
        @click="continueConversation()"
        v-if="showOverlayButtons"
        v-t="overlayResumeButtonText"
      ></button>
      <button
        class="restartButton"
        @click="restartConversation()"
        v-if="showOverlayButtons"
        v-t="overlayRestartButtonText"
      ></button>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Storage from '@/services/storageLib'
import { constantStrings, jsonConfigTemplate } from '@/services/constants'
import { getConstantValue } from '@/services/utils'

export default {
  data() {
    return {
      isUserInactive: false
    }
  },
  watch: {
    '$store.state.isOverlayActive': function () {
      this.isUserInactive = this.$store.state.isOverlayActive
      const { footerStatus } = this.$store.state.widgetConfig
      if (
        this.$store.state.isOverlayActive &&
        !this.$store.state.widgetConfig.inactiveOverlay.showButtons
      ) {
        this.$store.dispatch('endChat', {
          message: getConstantValue(constantStrings.SESSION_HAS_EXPIRED)
        })
      }
      if (!footerStatus) {
        this.$store.dispatch(
          'updateInputFieldDisableStatus',
          this.isUserInactive
        )
      } else if (footerStatus && footerStatus === constantStrings.DISABLED) {
        this.$store.dispatch('updateInputFieldDisableStatus', true)
      } else if (footerStatus && footerStatus === constantStrings.HIDDEN) {
        this.$store.dispatch('updateInputFieldHiddenStatus', true)
      }
    }
  },
  computed: {
    isSlotPresent() {
      return this.$slots.default
    },
    overlayResumeButtonText() {
      return this.$store.state.widgetConfig?.inactiveOverlay?.resumeButtonText
        ? jsonConfigTemplate.INACTIVE_OVERLAY_RESUME_BUTTON_TEXT
        : ''
    },
    overlayRestartButtonText() {
      return this.$store.state.widgetConfig?.inactiveOverlay?.restartButtonText
        ? jsonConfigTemplate.INACTIVE_OVERLAY_RESTART_BUTTON_TEXT
        : ''
    },
    overlayDescriptionText() {
      return this.$store.state.widgetConfig?.inactiveOverlay?.descriptionText
        ? jsonConfigTemplate.INACTIVE_OVERLAY_DESCRIPTION_TEXT
        : ''
    },
    showOverlayButtons() {
      return this.$store.state.widgetConfig?.inactiveOverlay?.showButtons
    }
  },
  methods: {
    async continueConversation() {
      this.$store.dispatch('updateOverlayStatus', false)
      Storage.setLocalStorageData('overlayStatus', false)
      this.$store.dispatch('overlayIdleChatTimeout')
      this.$store.dispatch('throttleIdleChatTimeout') // Throttle chat session timeout
      this.$store.dispatch('setIdleTimerForSurvey') // set idle timer for survey form triggering
      await this.$store.dispatch('sendIoTEvent', {
        event_name: 'OVERLAY_STATUS_RESUME',
        data: false
      })
    },
    async restartConversation() {
      this.$store.dispatch('updateOverlayStatus', false)
      Storage.setLocalStorageData('overlayStatus', false)
      this.$store.dispatch('clearChats')
      this.$store.dispatch('endChat', {
        message: getConstantValue(constantStrings.CHAT_ENDED),
        publishEventToIoT: false
      })
      await this.$store.dispatch('sendIoTEvent', {
        event_name: 'OVERLAY_STATUS_RESTART',
        data: false
      })
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/css/theme.scss';
.resumeButton {
  width: 188px;
  min-height: 40px;
  background: var(--widget-primary-color);
  @include border-radius(var(--radius-chat-inner-component));
  border: none;
  color: #fff;
  margin: 5px auto;
  display: block;
  cursor: pointer;
  &:focus-visible {
    outline: 4px inset #639af9;
  }
}

.restartButton {
  width: 188px;
  min-height: 40px;
  border: 1px solid var(--widget-primary-color);
  @include border-radius(var(--radius-chat-inner-component));
  color: var(--widget-primary-color);
  background: none;
  margin: 0 auto;
  display: block;
  cursor: pointer;
  &:focus-visible {
    outline: 4px inset #639af9;
  }
}

.descriptionText {
  width: 231px;
  height: auto;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  color: #000000;
  margin: 0 auto;
  text-align: center;
}

.overlayDiv {
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 3;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  bottom: 0;
  width: 100%;
  background: rgba(255, 255, 255, 0.9);
}
</style>
